/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lg-container[_ngcontent-%COMP%]{padding:1rem}.l-h-2[_ngcontent-%COMP%]{line-height:2.375rem}.select-list[_ngcontent-%COMP%]{float:right;width:50%;height:1rem}.select-list[_ngcontent-%COMP%] > option[_ngcontent-%COMP%]{padding:.5rem}.select-box[_ngcontent-%COMP%]{display:inline-block;width:60%;float:right}"];
export { styles as styles };
